let validQC = (rule, value, callback) => {
  if (value) {
    if (/[\u4E00-\u9FA5]/g.test(value)) {
      callback(new Error("不能输入汉字"));
    } else {
      // 验证通过
      callback();
    }
    callback();
  }
};

export const billEditFormRules = {
  custMblContact: [
    {
      required: true,
      message: "单证联系人不能为空",
      trigger: ["blur", "change"],
    },
    { validator: validQC, trigger: "blur" }
  ],
  custMblContactTel: [
    {
      required: true,
      message: "单证联系人电话不能为空",
      trigger: ["blur", "change"],
    },
    { validator: validQC, trigger: "blur" }
  ],
  custDocEmail: [
    {
      required: true,
      message: "单证联系人邮箱不能为空",
      trigger: ["blur", "change"],
    },
    { validator: validQC, trigger: "blur" }
  ],
  billType: [
    {
      required: true,
      message: "提单种类不能为空",
      trigger: ["blur", "change"],
    },
    { validator: validQC, trigger: "blur" }
  ],
  issueMode: [
    {
      required: true,
      message: "签单方式不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  placeOfIssueName: [
    {
      required: true,
      message: "签单地点不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  blPlaceOfDeliveryName: [
    {
      required: true,
      message: "提单交货地不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  blPorName: [
    { validator: validQC, trigger: "blur" }
  ],
  blPotName: [
    {
      required: true,
      message: "提单中转港不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  blPolName: [
    {
      required: true,
      message: "提单装货港不能为空",
      trigger: ['blur',"change"]
    },
  ],
  blPodName: [
    {
      required: true,
      message: "提单卸货/中转港不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  blPlaceOfDestName: [
    { validator: validQC, trigger: "blur" }
  ],
 /*  scacCode: [
    {
      required: true,
      message: "不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  aciCode: [
    {
      required: true,
      message: "不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ],
  houseBlNo: [
    {
      required: true,
      message: "不能为空",
      trigger: ['blur',"change"]
    },
    { validator: validQC, trigger: "blur" }
  ], */
}

export function BoxInfoValidate () {
  const billBoxInfoTableRules = [
    {
      property: 'ctnNo',
      ruleName: "notNull",
      message: "箱号不能为空"
    },
    {
      min: 0,
      max: 50,
      property: 'ctnNo',
      ruleName: "richLength",
      message: "长度不能超过50"
    },
    {
      property: 'sealNo',
      ruleName: "notNull",
      message: "封铅号不能为空"
    },
    {
      property: 'ctnSizeType',
      ruleName: "notNull",
      message: "箱型不能为空"
    },
    {
      property: 'noOfPackage',
      ruleName: "notNull",
      message: "件数不能为空"
    },
    {
      property: 'packageTypeName',
      ruleName: "notNull",
      message: "包装单位不能为空"
    },
    {
      property: 'grossWeight',
      ruleName: "notNull",
      message: "毛重(KGS)不能为空"
    },
    {
      property: 'cube',
      ruleName: "notNull",
      message: "体积(CBM)不能为空"
    },
    {
      property: 'fclLclFlag',
      ruleName: "notNull",
      message: "整拼标志不能为空"
    },
    { validator: validQC, trigger: "blur" }
  ];
  return billBoxInfoTableRules;
}



export function BillCargoInfoValidate () {
  const BillCargoInfoTableRules = [
    {
      property: 'mblNo',
      ruleName: "notNull",
      message: "提单号不能为空"
    },
    {
      property: 'hsCode',
      ruleName: "notNull",
      message: "HS CODE不能为空"
    },
    {
      property: 'cargoDescription',
      ruleName: "notNull",
      message: "货物描述不能为空"
    },
    {
      property: 'noOfPackage',
      ruleName: "notNull",
      message: "件数不能为空"
    },
    {
      property: 'packageTypeCode',
      ruleName: "notNull",
      message: "包装单位不能为空"
    },
    {
      property: 'grossWeight',
      ruleName: "notNull",
      message: "毛重不能为空"
    },
    {
      property: 'cube',
      ruleName: "notNull",
      message: "体积不能为空"
    },
  ];
  return BillCargoInfoTableRules;
}
